





















import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PdPatientEducationPlan from "./parts/pdPatientEducationPlan/index.vue";
import PdEducationPlan from "./parts/pdEducationPlan/index.vue";
import PdKnowledge from "../pdOutPatient/pdEducation/pdKnowledge/index.vue";
@Component({})
export default class PdEducationPlanTab extends AbpBase {
  @Prop() patient: any;
  currentTab: string = "tabPdPatientEducationPlan";
  tabs: any = [
    {
      label: "宣教计划查询",
      name: "tabPdPatientEducationPlan",
      component: PdPatientEducationPlan
    },    
    {
      label: "宣教计划",
      name: "tabPdEducationPlan",
      component: PdEducationPlan
    },
    {
      label: "宣教材料",
      name: "tabPdKnowledge",
      component: PdKnowledge
    }
  ];

  //点击tab时才显示页面
  handleClickTab(tabName: string) {
    this.currentTab = tabName;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdEducationPlan/index.vue